<app-breadcrumb [master]="'Należności'" [parentName]="'Wpłaty'" [name]="'Dodaj'"></app-breadcrumb>
<div class="regional-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane wpłaty</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Tytuł przelewu</mat-label>
                <input appCapitalizeFirst matInput placeholder="Tytuł przelewu" [formControl]="transferTitleControl">
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Kwota przelewu</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="Kwota przelewu"
                  [formControl]="transferAmountControl"
                  step="0.01"
                />
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div  fxFlex="100">
              <app-dict-receivables-balance fxFlex="100" label="Saldo" [formControl]="receivablesBalanceControl" [required]="true">
                ></app-dict-receivables-balance>
            </div>


          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <input appCapitalizeFirst matInput placeholder="Uwagi" [formControl]="noteControl">
              </mat-form-field>
            </div>

          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

